module.exports = __webpack_public_path__ + "static/quiz4_question6-c53c0893beaca314d436a7ff50ca633e.jpg";